import React, { useEffect, useRef, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import userService from "../../Services/UserService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import { getIcons } from "../../Constant/Constant";
import Loader from "../../Constant/Loader";
import NotFound from "../../Form/NotFound/NotFound";
import CustomHeading from "../../common/CustomHeading";

const UserMain = () => {
  const icons = getIcons();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const categoriesRef = useRef([]);
  const [underlineStyle, setUnderlineStyle] = useState({});
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchList, setSearchList] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All Users");
  const [noUsers, setNoUsers] = useState();

  const navigate = useNavigate();
  const location = useLocation();
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  useEffect(() => {
    // Default behavior for initial load
    handleCategoryChange("All Users");
  }, []);

  useEffect(() => {
    if (location.state?.message) {
      showSuccessToast(location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const handleOpen = () => {
    if(userRole === "Admin"){

      navigate("/admin/user-creation");
    }else if(userRole === "CMO"){
      navigate("/cmo/user-creation");

    }
  };

  const handleUpdateUser = (user) => {
    if(userRole === "Admin"){

      navigate(`/admin/update-user/${user.uid}`, { state: { user } });
    } else if(userRole === "CMO"){
      navigate(`/cmo/update-user/${user.uid}`, { state: { user } });

    }
  };

  const handleCategoryChange = async (category) => {
    setSelectedCategory(category);
    setLoading(true);

    try {
      const response = await userService.fetchUsers(category);

      const sortedUsers = response.data.sort(
        (a, b) => new Date(b.lastModifiedTime) - new Date(a.lastModifiedTime)
      );

      if (sortedUsers.length === 0) {
        setNoUsers("No users");
        setUsers([]);
        setFilteredUsers([]);
      } else {
        setUsers(sortedUsers);
        const filteredResults = sortedUsers.filter((user) =>
          user.name.toLowerCase().includes(searchList.toLowerCase())
        );
        setFilteredUsers(filteredResults);
        setNoUsers(null);
      }
    } catch (err) {
      console.error(err);
      setNoUsers("An error occurred while fetching users.");
      setUsers([]);
      setFilteredUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const currentCategory = categoriesRef.current.find(
      (cat) => cat.textContent === selectedCategory
    );
    if (currentCategory) {
      setUnderlineStyle({
        left: currentCategory.offsetLeft,
        width: currentCategory.clientWidth,
      });
    }
  }, [selectedCategory]);

  const handleSearchChange = (e) => {
    setSearchList(e.target.value);
    const filteredResults = users.filter((user) =>
      user.name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredUsers(filteredResults);
  };

  return (
    <div className="bg-appGrayBackground  pb-16 pt-20">
      {loading ? <Loader/> : ""}
      <AdminAppBar />
      <ToastContainer/>
      <div className="my-10 px-20 xl:px-6 relative flex justify-between gap-5">
     
          <CustomHeading title={`Users (${filteredUsers.length})`} isIcon={true}/> 
      

        <div className="relative flex w-[700px] 4xl:w-[1600px] 2xl:w-[900px] 3xl:w-[1300px] items-center ">
          <img
            src={icons.searchIcon}
            alt=""
            className="absolute left-4 w-5 h-5"
          />
          <input
            type="text"
            placeholder="Search User by Name"
            value={searchList}
            onChange={handleSearchChange}
            className="setup-search pl-10 pr-4  h-10 border-stone-400 shadow appearance-none border rounded text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>

        <div>
          <button
            onClick={handleOpen}
            className="border-2 whitespace-nowrap border-customGreen rounded-sm p-1 px-5 mt-2 text-lg text-customGreen h-10 text-center"
          >
            +Create a New User
          </button>
        </div>
      </div>

      <div className="list-container bg-white mt-10 rounded-md shadow-md w-12/12 pt-6 pb-6 mx-20 xl:mx-6 max-h-[700px] 4xl:max-h-[900px]  ">
        <div className="flex mb-8 justify-around border-slate-400 border-t-0 border-b-2 h-10 border-l-0 pb-1 relative ">
          {[
            "All Users",
            "BOD",
            "Telecaller",
            "Marketing Executive",
            "Field Worker",
            "MD",
            "Admin",
            "Lead Uploader",
            "CMO"
          ].map((category, index) => (
            <h1
              key={category}
              ref={(el) => (categoriesRef.current[index] = el)}
              className={`text-xl cursor-pointer 4xl:text-3xl ${
                selectedCategory === category ? "text-green-500" : ""
              }`}
              onClick={() => handleCategoryChange(category)}
            >
              {category}
            </h1>
          ))}
          <span
            className="absolute top-9 h-1 bg-green-500 transition-all duration-300"
            style={underlineStyle}
          />
        </div>

        <div className="w-12/12">
          <div className=" overflow-y-auto max-h-[300px] 3xl:max-h-[500px] xl:max-h-[470px] 2xl:max-h-[450px] lg:max-h-[470px] 4xl:max-h-[750px]  custom-scrollbar">
            {/* {loading ? (
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
              </div>
            ) : ( */}
              <table className="w-full table-fixed ">
                <thead className="bg-white sticky top-0">
                  <tr className="border-b">
                    <th className="text-customGreen text-2xl font-medium w-1/4 4xl:text-3xl">
                      Name
                    </th>
                    <th className="text-customGreen text-2xl font-medium w-1/4 4xl:text-3xl">
                      Role
                    </th>
                    <th className="text-customGreen text-2xl font-medium w-1/4 4xl:text-3xl">
                      Team
                    </th>
                    <th className="text-customGreen text-2xl font-medium w-1/4 4xl:text-3xl">
                      Status
                    </th>
                    <th className="text-customGreen text-2xl font-medium w-20"></th>
                  </tr>
                </thead>
                <tbody className="px-20">
                  {filteredUsers.length > 0 ? (
                    filteredUsers.map((user) => (
                      <tr
                        key={user.id}
                        className="h-14 w-full text-center font-medium border-b xl:text-sm 3xl:text-lg 4xl:text-2xl"
                      >
                        <td className="py-4">
                          <div className="flex items-center px-10">
                            <span className="text-4xl text-customGreen mr-2 ">
                              &bull;
                            </span>
                            <div className="flex flex-col text-left">
                            <div
  className="max-w-[200px] cursor-pointer truncate xl:text-sm 3xl:text-lg 4xl:text-2xl"
  title={user.name}
>
  {user.name}
</div>
                              <div className="font-light 3xl:text-lg 4xl:text-2xl">
                                Emp ID: {user.employeeId || "N/A"}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>{user.role}</td>
                        <td className="text-ellipsis overflow-hidden">
  {user?.teamName?.[0]?.name || "N/A"}
</td>

                        <td>
                          <button
                            className={`w-28 h-10 rounded-md cursor-default shadow-lg text-white ${
                              user.status ? "bg-green-600" : "bg-red-600"
                            }`}
                          >
                            {user.status ? "Active" : "Deactive"}
                          </button>
                        </td>
                        <td className="w-10">
                          <div
                            className="text-sky-400 cursor-pointer"
                            onClick={() => handleUpdateUser(user)}
                          >
                            Edit
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                       
                      >
                       <NotFound title={"User Not Found"} />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            {/* )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserMain;
